module.exports = __webpack_public_path__ + "img/113.08919992.jpg";